export enum PlaceType {
    WORKSHOP = '1001',
    OFFICE = '1002'
}